import { render } from "./add_paystack_model.vue?vue&type=template&id=74783ab7"
import script from "./add_paystack_model.vue?vue&type=script&lang=js"
export * from "./add_paystack_model.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__